import React, { ReactNode } from "react";
import styles from "./index.module.scss";

export const BANNER_LINK =
  "https://promotion.pddpic.com/promo/dmp/agreement_banner.png.slim.png";

export interface FeatureItem {
  src: string;
  title: string;
  description: ReactNode;
}

export const FEATURE_LIST: FeatureItem[] = [
  {
    title: "人群资产整合",
    src: "https://promotion.pddpic.com/promo/dmp/agreement_group.png.slim.png",
    description: "提供人群维度的数据洞察，提供人群分析及应用能力",
  },
  {
    title: "精细化运营能力",
    src: "https://promotion.pddpic.com/promo/dmp/agreement_operations.png.slim.png",
    description: "根据人群资产和人群画像分析，制定适合自己的运营策略",
  },
  {
    title: "行业趋势洞悉",
    src: "https://promotion.pddpic.com/promo/dmp/agreement_trend.png.slim.png",
    description: "帮助挖掘市场潜力类目，更好地洞察类目趋势，寻求机会",
  },
];

export const LABEL_ICON =
  "https://promotion.pddpic.com/promo/dmp/agreement_label.png.slim.png";
export const LABEL_PREVIEW =
  "https://promotion.pddpic.com/promo/dmp/agreement_label_preview.png.slim.png";

export const GOODS_ICON =
  "https://promotion.pddpic.com/promo/dmp/agreement_goods.png.slim.png";
export const GOODS_PREVIEW =
  "https://promotion.pddpic.com/promo/dmp/agreement_goods_preview.png.slim.png";

export const MALL_LIST: FeatureItem[] = [
  {
    title: "PU****旗舰店",
    src: "https://promotion.pddpic.com/promo/dmp/agreement_mall_pu.png.slim.png",
    description: (
      <>
        使用数据资产管理系统人群包投放「首页弹窗资源位」带来
        <span className={styles.highlight}>60w+</span>精准曝光
      </>
    ),
  },
  {
    title: "唯**旗舰店",
    src: "https://promotion.pddpic.com/promo/dmp/agreement_mall_yui.png.slim.png",
    description: (
      <>
        使用数据资产管理系统人群包投放「大促资源位」带来
        <span className={styles.highlight}>73w+</span>精准曝光
      </>
    ),
  },
];
